(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-topbar-message"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-topbar-message]").forEach((topbar) => {

      const btn = topbar.querySelector("[data-btn-close]");

      btn?.addEventListener("click", () => {
        topbar.style.display = "none";
      });

    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-blocks-grid"] && !Shopify.designMode) return;
  try {
    
  function initBannerSliders() {
    const allSwipers = document.querySelectorAll('.swiper');

    allSwipers.forEach((container) => {
      const slides = container.querySelectorAll('.swiper-slide');

      // Solo activamos el slider si hay 2 o más bloques en esa posición
      if (slides.length > 1) {
        new Swiper(container, {
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: container.querySelector('.swiper-pagination'),
            clickable: true,
          },
        });
      } else if (slides.length === 1) {
        // Si hay solo uno, nos aseguramos de que no tenga clases de swiper que estorben
        container.classList.add('swiper-static');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initBannerSliders);
  // Vital para que funcione en el editor de Shopify sin refrescar
  document.addEventListener('shopify:section:load', initBannerSliders);

  } catch(e) { console.error(e); }
})();
})();
